class CardInlineAdd extends HTMLElement {
  connectedCallback() {
    const jsonEl = this.querySelector('[data-variant-json]');
    this.variantData = jsonEl ? JSON.parse(jsonEl.textContent) : [];
    const pricingEl = this.querySelector('[data-pricing-json]');
    this.pricingData = pricingEl ? JSON.parse(pricingEl.textContent) : {};
    this.form = this.querySelector('.card-inline-add__form');
    this.variantInput = this.querySelector('[data-card-variant-id]');
    this.atcBtn = this.querySelector('[data-card-atc-btn]');
    this.subscribeBtn = this.querySelector('[data-subscribe-atc-btn]');
    this.sellingPlanId = this.dataset.sellingPlanId || null;
    this.selectedOptions = [];

    const initialVariantId = this.variantInput ? parseInt(this.variantInput.value) : null;
    if (initialVariantId) {
      const initialVariant = this.variantData.find((v) => v.id === initialVariantId);
      if (initialVariant) {
        for (let i = 0; i < 3; i++) {
          if (initialVariant[`option${i + 1}`]) {
            this.selectedOptions[i] = initialVariant[`option${i + 1}`];
          }
        }
      }
    }

    this.querySelectorAll('[data-option-value]').forEach((btn) => {
      btn.addEventListener('click', this.onOptionClick.bind(this));
    });

    if (this.form) {
      this.form.addEventListener('submit', this.onSubmit.bind(this));
    }

    if (this.subscribeBtn) {
      this.subscribeBtn.addEventListener('click', this.onSubscribeClick.bind(this));
    }
  }

  onOptionClick(e) {
    const btn = e.currentTarget;
    const optionIndex = parseInt(btn.dataset.optionIndex);
    const value = btn.dataset.optionValue;

    this.selectedOptions[optionIndex] = value;

    this.querySelectorAll(`[data-option-index="${optionIndex}"]`).forEach((b) => {
      b.classList.toggle('is-active', b.dataset.optionValue === value);
    });

    const match = this.variantData.find((v) =>
      this.selectedOptions.every((opt, i) => opt === undefined || v[`option${i + 1}`] === opt)
    );

    if (match && this.variantInput) {
      this.variantInput.value = match.id;
      this.updatePricing(String(match.id));
    }
  }

  updatePricing(variantId) {
    const data = this.pricingData[variantId];
    if (!data) return;

    const regularPriceEl = this.querySelector('[data-regular-price]');
    if (regularPriceEl) regularPriceEl.textContent = data.price;

    const priceAmountEl = this.querySelector('[data-price-amount]');

    if (this.subscribeBtn) {
      if (data.subscribe_price) {
        if (priceAmountEl) priceAmountEl.textContent = data.subscribe_price;
        this.subscribeBtn.hidden = false;
      } else {
        this.subscribeBtn.hidden = true;
      }
    }
  }

  dispatchCartAdd(btn) {
    if (!btn || btn.disabled) return;

    document.addEventListener(
      'theme:product:added',
      () => {
        btn.classList.remove('is-loading');
        btn.classList.add('is-added');
        btn.disabled = false;

        setTimeout(() => {
          btn.classList.remove('is-added');
        }, 2000);
      },
      { once: true }
    );

    document.addEventListener(
      'theme:product:error',
      () => {
        btn.classList.remove('is-loading');
        btn.disabled = false;
      },
      { once: true }
    );

    document.dispatchEvent(
      new CustomEvent('theme:cart:add', {
        detail: { button: btn },
      })
    );
  }

  onSubmit(e) {
    e.preventDefault();
    this.removeSellingPlanInput();
    this.dispatchCartAdd(this.atcBtn);
  }

  onSubscribeClick(e) {
    e.preventDefault();
    if (!this.sellingPlanId) return;
    this.setSellingPlanInput(this.sellingPlanId);
    this.dispatchCartAdd(this.subscribeBtn);
  }

  setSellingPlanInput(planId) {
    let input = this.form.querySelector('input[name="selling_plan"]');
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'selling_plan';
      this.form.appendChild(input);
    }
    input.value = planId;
  }

  removeSellingPlanInput() {
    const input = this.form.querySelector('input[name="selling_plan"]');
    if (input) input.remove();
  }
}

customElements.define('card-inline-add', CardInlineAdd);
